import { GetOffersResult } from '@west-australian-newspapers/subscription-offer-types'
import { SubscriptionPackageOptions } from '../user-registration/breach/helpers/BreachWallTypes'

export type OfferGroupType = 'breach' | 'campaigns'

/** TODO: Migrate away from SubscriptionPackageOptions and align directly with API */
export const transformOffersResultToPackageOption = (
    offerGroup: OfferGroupType,
    apiOffers?: GetOffersResult,
): Record<string, SubscriptionPackageOptions[]> => {
    if (!apiOffers || apiOffers.offerGroup !== offerGroup) {
        return {}
    }

    const result: Record<string, SubscriptionPackageOptions[]> = {}

    apiOffers.variants.map(({ variant, offers }) => {
        result[variant] = offers as unknown as SubscriptionPackageOptions[]
    })

    return result
}
